export const queryOptions = {
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
  cacheTime: Infinity,
};
